// export function navigationMobile() {

//     $(function() {
//         $(".toggle-menu").click(function() {
//             $(this).toggleClass("active");
//             $('.mainMenuMobile').toggleClass("open");

//             // Overlay anzeigen/verstecken
//             $('#overlay').toggleClass('active');

//             // Body-Scroll sperren/entsperren
//             if ($('body').css('overflow') === 'hidden') {
//                 $('body').css('overflow', '');
//             } else {
//                 $('body').css('overflow', 'hidden');
//             }

//             // Suche schließen, falls offen
//             const $searchWrapper = $('#vs-search-wrapper');
//             const $searchBtn     = $('.search-open');
//             if ($searchWrapper.hasClass('active')) {
//                 $searchWrapper.removeClass('active')
//                     .attr('aria-hidden', 'true');
//                 $searchBtn.attr('aria-expanded', 'false');
//             }
//         });
//     });

//     $(function() {
//     const navToggle = document.querySelector('.menu-toggle');
//     const header = document.querySelector('.vs-main-navigation');
//         navToggle && navToggle.addEventListener('click', function() {
//             header.classList.toggle('menu-is-open');
//         });
//     });


//     $(function() {
//         $('.open-sub-menu').click(function(e) {
//             e.preventDefault();
//             var parentLi = $(this).closest('li.has-children');
//             parentLi.find('> .vs-main-menu-mobile-sub-menu').first().css({'transform': 'translateX(0%)', 'opacity': '1', 'visibility': 'visible'});
//         });

//         $('.vs-main-menu-mobile-sub-menu__menu-back').click(function(e) {
//             e.preventDefault();
//             $(this).closest('.vs-main-menu-mobile-sub-menu').css({'transform': 'translateX(100%)', 'opacity': '0', 'visibility': 'hidden'});
//         });
//     });


// }


export function navigationMobile() {
    const burgerBtn = document.querySelector('.hamburger-btn');
    const mobileMenu = document.querySelector('#mobile-menu');

    if (!burgerBtn || !mobileMenu) return;

    // Funktion zum Umschalten des Menüs
    const toggleMobileMenu = () => {
        const isExpanded = burgerBtn.getAttribute('aria-expanded') === 'true';
        
        // Button State
        burgerBtn.classList.toggle('is-active');
        burgerBtn.setAttribute('aria-expanded', !isExpanded);
        
        // Menu State
        mobileMenu.classList.toggle('is-open');
        mobileMenu.setAttribute('aria-hidden', isExpanded);
        
        // Body Scroll verhindern, wenn offen
        if (!isExpanded) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    };

    // Click Event auf Hamburger
    burgerBtn.addEventListener('click', toggleMobileMenu);

    // Menü schließen, wenn auf einen Link geklickt wird (wichtig für Anker-Links)
    const mobileLinks = mobileMenu.querySelectorAll('.mobile-nav-link, .btn-mobile-cta');
    mobileLinks.forEach(link => {
        link.addEventListener('click', () => {
            if (mobileMenu.classList.contains('is-open')) {
                toggleMobileMenu();
            }
        });
    });

    // Sicherheits-Reset: Wenn das Browserfenster auf Desktop-Größe gezogen wird,
    // schließen wir das mobile Menü automatisch und geben den Scroll frei.
    window.addEventListener('resize', () => {
        if (window.innerWidth >= 1000 && mobileMenu.classList.contains('is-open')) {
            burgerBtn.classList.remove('is-active');
            burgerBtn.setAttribute('aria-expanded', 'false');
            mobileMenu.classList.remove('is-open');
            mobileMenu.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }
    });
}